import { urls } from '@/config/urls';
import { instance } from '@/config/axios';

let processAbortController;
export { processAbortController };

const { server } = urls;

export default {

  getProcessHistory(page, max) {
    processAbortController = new AbortController();
    return instance.get(`${server.process.process_history}?page=${page}&page_size=${max}`,)
      .then(response => response)
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getProcessHistoryById(processId) {
    return instance.get(`${server.process.process_history}/${processId}`,)
      .then(res => {
        const process = res.data;
        return {
          optimization_id: process.id,
          start_time: process.triggered,
          route_start: process.range.start,
          state: process.status,
          progress: 1,
        };
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getLastSuccessfulProcess() {
    return instance.get(`${server.process.process_history}?page=1&page_size=10`,)
      .then(response => { 
        return {
          process_id: response.data.results[0]?.optimization_id,
          start_time: response.data.results[0]?.timestamp,
        };
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getProcessIds (page) {
    let params = `?page=${page}&page_size=${20}`;
    processAbortController = new AbortController();
    return instance.get(`${server.process.history}${params}`, {
      signal: processAbortController.signal
    })
      .then(response => response)
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  abortFetch () {
    return new Promise((resolve) => {
      resolve(false);
    });
  },

  // Version history for one optimization: { results: [{ version_id, source_type, timestamp }], total_pages, count }.
  getOptimizationVersions(optimizationId, page = 1, max = 50) {
    return instance.get(
      `${server.process.history}${optimizationId}/versions?page=${page}&page_size=${max}`,
    )
      .then(response => response)
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getProcessById(id, config = {}) {
    return instance.get(`${server.process.summary}${id}`, config);
  },
  getOptimizationStatus(id, config = {}) {
    return instance.get(`${server.process.summary}${id}/status`, config);
  }
};
